import React, { useState } from 'react';
import { LogOut } from 'lucide-react';
import ClickOutside from '../ClickOutside';
import UserOne from '../../../../images/user/user-01.png';
import { LocalStorageService } from '../../../../configuration';
import { googleLogout } from '@react-oauth/google';
import { logoutCmsAPI } from '../../../../api/authentication/login.api';

const DropdownUser = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const handleLogout = async () => {
    // QA S-28: revoke refresh token phía server trước khi xoá local (best-effort, lỗi vẫn logout local).
    try {
      const cmsRefreshToken = LocalStorageService.getItem('cmsRefreshToken');
      if (cmsRefreshToken) await logoutCmsAPI(cmsRefreshToken);
    } catch {
      /* revoke lỗi vẫn tiếp tục logout local */
    }
    LocalStorageService.removeItem('cmsAccessToken');
    LocalStorageService.removeItem('cmsFingerprintHash');
    LocalStorageService.removeItem('cmsRefreshToken');
    googleLogout();
    window.location.href = '/admin/login'; // reload sạch state trong bộ nhớ (tránh state cũ sót lại sau logout)
  };
  return (
    <ClickOutside onClick={() => setDropdownOpen(false)} className="relative">
      <button
        type="button"
        aria-haspopup="true"
        aria-expanded={dropdownOpen}
        onClick={() => setDropdownOpen(!dropdownOpen)}
        className="adm-user-chip"
      >
        <span className="hidden sm:inline">Admin</span>
        <img className="adm-user-chip__avatar" src={UserOne} alt="Admin" />
      </button>

      {dropdownOpen && (
        <div className="adm-popover">
          <button type="button" className="adm-menu-item adm-menu-item--danger" onClick={handleLogout}>
            <LogOut size={18} aria-hidden="true" />
            Đăng xuất
          </button>
        </div>
      )}
    </ClickOutside>
  );
};

export default DropdownUser;
